import { createSlice } from "@reduxjs/toolkit";

type Step =
  | "ACCOUNTS"
  | "REDIRECT"
  | "DETAILS"
  | "CONFIRM"
  | "STATUS"
  | "FEEDBACK"
  | "JOINT_SIGNATURE";

interface InitialState {
  openModal: boolean;
  step: Step;
  status: "SUCCESS" | "ERROR" | null;
  selectedAccount: string;
}

const initialState: InitialState = {
  openModal: false,
  step: "ACCOUNTS",
  status: null,
  selectedAccount: "",
};

const cryptoSlice = createSlice({
  name: "cryptoData",
  initialState,
  reducers: {
    openCryptoModal: (state) => {
      state.openModal = true;
    },
    closeCryptoModal: (state) => {
      state.openModal = false;
    },
    updateCryptoStep: (state, action) => {
      state.step = action.payload;
    },
    updateCryptoStatus: (state, action) => {
      state.status = action.payload;
    },
    updateCryptoSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
  },
});

export const {
  openCryptoModal,
  closeCryptoModal,
  updateCryptoStep,
  updateCryptoStatus,
  updateCryptoSelectedAccount,
} = cryptoSlice.actions;
export default cryptoSlice.reducer;
